import useStore from './_store';
import { SET_AGENTS, GET_AGENTS, GET_TEAM_SLIDER_AGENTS } from './_store/types';
import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { usePageStore } from '@/store';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
import util from '@/common/util';
import spaceMixin from '@/modules/space-mixin';
import styleMixin from '@/modules/color-mixin';
import { leadTypes } from '../../common/const';
import AgentHeadShot from "@/components/agent-headshot.vue"

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-form'
    },
    asyncData: mapAsyncData(asyncData),
    mixins: [spaceMixin(), styleMixin()],
    data: function() {
        return {
            noAgent: false,
            agentId: 0,
            secondAgentId: -1,
            title: "",
            defaultMsg: '',
            registerRole: leadTypes.Buyer,
            tag: '', //SITE-12720
            bgType: 'color',
            bgColor: '',
            formBgColor: '',
            agentBgColor: '',
            maskOption: {
                showMark: false,
                maskColor: ''
            },
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            },
            questionnaire: {},
            oldFormList: [],
            formList: [],
            showTitle: false,
            showLender: true,
            lenderStyle: {},
            submitOption: {},
            submitBgColor: '',
            pageType: '', //listing-detail/listing-detail-sold,  For details page
            originPriority: false, // Whether to give priority to listing listings agent， For details page
            year: new Date().getFullYear(), // Copyright  year of
            formToastVisible: false, //form-toast whether to display
            rightToastVisible: false,
            onSubmitOption: {
                type: 'toast',
                toastMsg: "",
                destinationMsg: "",
                buttonText: '',
                url: '/',
                toastDelay: 0
            },
            registerLogin: false,
            isSkipStepToOpenUrl: false, // skip filling oneLastStep steps and Toast open directly url
            agentLoaded: !util.isClient, //
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png',
            submitOptionStyle: {},
            rightSubmitOptionStyle: {}
        };
    },
    components: {
        AgentHeadShot
    },
    watch: {
        originPriority() {
            this.getAgentInfo(this.agentId);
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            global: store => store.page || {},
            rootAgents: store => store.agents,
            agentCreator: store => store.page?.agentCreator || {}
        }),
        ...mapState({
            formListState: store => store.formListState,
            agents: store => store.agents,
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        wordPressSSR({ global }) {
            return global.wordPressSSR;
        },
        licenseName({ global }) {
            return global.licenseName;
        },
        pageKey({ global }) {
            return global.pageKey;
        },
        useBgSrc() {
            return util.getImgSrcByPlatform(this.bgImgOpt, this.isMobileSize);
        },
        isListingDetail() {
            return (
                this.pageType == 'listing-detail' ||
                this.pageType == 'listing-detail-sold'
            );
        },
        isBuildingDetail({ pageKey }) {
            //  judge whether buildingDetail page
            return pageKey === 'building';
        },
        //form-toast propData
        formToastOption() {
            const option = this.onSubmitOption;
            return this.onSubmitOption.type === 'toast'
                ? {
                    showFooter: false,
                    showMark: true,
                    content: option.toastMsg,
                    duration: option.toastDelay || 3000,
                    confirmButtonStyle: {
                        backgroundColor: this.submitBgColor
                    },
                    iconStyle: {
                        color: this.submitBgColor
                    }
                }
                : {
                    showFooter: true,
                    showMark: true,
                    content: option.destinationMsg,
                    confirmButtonText: option.buttonText,
                    confirmButtonStyle: {
                        backgroundColor: this.submitBgColor
                    },
                    iconStyle: {
                        color: this.submitBgColor
                    }
                };
        },
        formToastOptionRight() {
            const option = this.rightOnSubmitOption;
            return this.rightOnSubmitOption.type === 'toast'
                ? {
                    showFooter: false,
                    showMark: true,
                    content: option.toastMsg,
                    duration: option.toastDelay || 3000,
                    confirmButtonStyle: {
                        backgroundColor: this.submitBgColor
                    },
                    iconStyle: {
                        color: this.submitBgColor
                    }
                }
                : {
                    showFooter: true,
                    showMark: true,
                    content: option.destinationMsg,
                    confirmButtonText: option.buttonText,
                    confirmButtonStyle: {
                        backgroundColor: this.submitBgColor
                    },
                    iconStyle: {
                        color: this.submitBgColor
                    }
                };
        },
        agent() {
            if (this.noAgent) {
                return {};
            } else if (
                this.isListingDetail &&
                this.originPriority &&
                this.listingDetail &&
                this.listingDetail.agentInfo
            ) {
                let agent = this.listingDetail.agentInfo;
                if (!agent.image) {
                    if (this.agentShape === 'circle') {
                        agent.image =
                            'https://cdn.chime.me/image/fs/sitebuild/2019916/23/original_96b7f1a8-9f97-424d-852a-ae5214ba95e9.png';
                    } else {
                        agent.image =
                            'https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png';
                    }
                }
                return agent;
            } else if (this.agentLoaded) {
                return this.rootAgents[this.agentId] || this.agentCreator;
            }
            return {};
        },
        submitOptionText({ submitOption }) {
            if (typeof submitOption === 'string') {
                return submitOption.replace(/<[^>]*>/g, '');
            } else {
                return submitOption.text;
            }
        },
        rightSubmitOptionText({ rightSubmitOption }) {
            if (typeof rightSubmitOption === 'string') {
                return rightSubmitOption.replace(/<[^>]*>/g, '');
            } else {
                return rightSubmitOption.text;
            }
        },
        showMask({ maskOption, bgType }) {
            return bgType === 'img' &&  maskOption?.showMask
        },
        maskColor({ showMask, maskOption }) {
            return showMask ? maskOption?.maskColor : ''
        },
        borderColorStyle({ inputBorderColor }) {
            let ret = {};
            ret['--input-border-color'] = inputBorderColor || 'rgba(218, 218, 218, 0.5)';
            return ret;
        }
    },
    afterAsyncData() {
        if (this.formListState?.length > 0) {
            this.formList = this.formListState;
        }
        if (
            !this.formList.length &&
            this.oldFormList &&
            this.oldFormList.length
        ) {
            this.formList = this.oldFormList.concat();
        }
        this.agentLoaded = true;
    },
    mounted() {
        this.year = new Date().getFullYear();
    },
    methods: {
        ...rootMapActions(usePageStore, {
            getAgentInfo: 'getAgentInfo'
        }),
        ...mapActions({
            setAgents: SET_AGENTS,
            getAgents: GET_AGENTS,
            getTeamSliderAgents: GET_TEAM_SLIDER_AGENTS
        }),
        getAgent() {
            this.getAgents({
                agentId: this.agentId,
                secondAgentId: this.secondAgentId,
                agentShape: this.agentShape
            });
        },
        // change cms data to form-toast needs and show form-toast
        handleShowToast(visible = true) {
            this.formToastVisible = visible;
        },
        handleShowToastRight(visible = true) {
            this.rightToastVisible = visible;
        },
        handleToastConfirm() {
            // jump to destination URL
            if (this.onSubmitOption.type === 'url') {
                window.open(
                    this.onSubmitOption.url,
                    this.onSubmitOption.target || '_blank'
                );
            }
        },
        handleToastConfirmRight() {
            // jump to destination URL
            if (this.rightOnSubmitOption.type === 'url') {
                window.open(
                    this.rightOnSubmitOption.url,
                    this.rightOnSubmitOption.target || '_blank'
                );
            }
        },
        async requestAgents() {
            if (this.theme === 'embedded' || this.theme == "layout12") {
                await this.getAgents({
                    agentId: this.agentId,
                    secondAgentId: this.secondAgentId,
                    agentShape: this.agentShape
                });
            } else if (this.theme === 'team-slider') {
                if (this.agentIds === '') {
                    this.setAgents([]);
                } else {
                    await this.getTeamSliderAgents(this.agentIds);
                }
            } else if (!this.noAgent && (this.agentId || this.agentId === 0)) {
                await this.getAgentInfo(this.agentId);
            }
        }
    }
};
